import { Navigate, RouteObject } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { WarehouseOrderEventAutomationsPage } from 'pages/WarehouseOrderEventAutomations';

const warehouseOrderEventAutomationsRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/automacao-apontamentos',
  element: userBelongsToAnyOf('admin') ? (
    <WarehouseOrderEventAutomationsPage />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
});

export default warehouseOrderEventAutomationsRoutes;
